import { ArrowLeftRight } from 'lucide-react';
import { data, dinheiro, nomeCadastro, nomeParceiro, textoLivre } from '../../nucleo/formato';
import { caminhoDaAba, type FonteBuscaGlobal } from '../../nucleo/modulos-web';
import { discretoAtivo } from '../../nucleo/discreto';

/**
 * Lista de 30/10 (item 10): movimentações do Financeiro na busca da barra superior (a busca da lista: descrição, parceiro e
 * valor). As Movimentações passaram a ler `?busca=`: o item abre a lista com a descrição; "Ver todos", com o termo.
 */
interface LancamentoBusca {
  id: string;
  descricao: string;
  parceiro_nome: string | null;
  conta_nome: string | null;
  valor_centavos: number;
  moeda: string;
  data_caixa: string;
}

const lista = (busca: string) => (busca ? `${caminhoDaAba('financeiro', 'entradas-saidas')}?busca=${encodeURIComponent(busca)}` : `${caminhoDaAba('financeiro', 'entradas-saidas')}`);

// Rodada rl30-2 (VIS-M2): com o modo discreto, o item não leva o texto do registro para a busca da lista (ficaria por extenso no
// campo e no endereço); a lista abre sem filtro. O "Ver todos" segue com o termo que a própria pessoa digitou.
export const buscaFinanceiro: FonteBuscaGlobal[] = [
  {
    chave: 'lancamentos',
    permissao: 'financeiro.ver',
    pagina: 'financeiro.entradas-saidas',
    grupo: 'buscaGlobal.lancamentos',
    posicao: 75,
    icone: ArrowLeftRight,
    item: (l: LancamentoBusca) => ({
      id: l.id,
      rotulo: textoLivre(l.descricao, l.parceiro_nome),
      detalhe: [data(l.data_caixa), dinheiro(l.valor_centavos, l.moeda), l.parceiro_nome ? nomeParceiro(l.parceiro_nome) : nomeCadastro(l.conta_nome)].filter(Boolean).join(' · '),
      link: discretoAtivo() ? lista('') : lista(l.descricao),
    }),
    verTodos: lista,
  },
];
